.circleAndTextContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}